"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[531],{

/***/ 121170:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = BlogTemplate1;

__webpack_require__(76265);

__webpack_require__(564043);

__webpack_require__(709873);

var _react = _interopRequireWildcard(__webpack_require__(667294));

var _BlogCard = _interopRequireDefault(__webpack_require__(736975));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function BlogTemplate1(props) {
  var _state$section9, _state$section9$secti, _state$section10, _state$section10$user, _state$section11;

  const [state, setState] = (0, _react.useState)({
    section: {}
  });
  const [isSourceWebConsole, setSource] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setState({
      section: props === null || props === void 0 ? void 0 : props.section
    });

    if ((props === null || props === void 0 ? void 0 : props.source) === "web-console") {
      setSource(true);
    }
  }, [props]);

  const onWrapperClick = dataReceived => {
    if (props.onElementClick && isSourceWebConsole) {
      props.onElementClick(_objectSpread(_objectSpread({}, dataReceived), {}, {
        templateId: props.templateId
      }));
    }
  };

  const onViewMoreBtnClick = () => {
    var _state$section;

    if (!isSourceWebConsole && (_state$section = state.section) !== null && _state$section !== void 0 && _state$section.slug) {
      var _state$section2;

      const link = window.location.href.split("");
      const ifLastCharSlash = link[link.length - 1] === "/";
      window.location.href = "".concat(window.location.href).concat(ifLastCharSlash ? "" : "/", "p/").concat((_state$section2 = state.section) === null || _state$section2 === void 0 ? void 0 : _state$section2.slug);
    }
  };

  const renderCard = cardTemplateId => {
    var _state$section3, _state$section3$users, _state$section4, _state$section5, _state$section6, _state$section6$users, _state$section7, _state$section8;

    switch (cardTemplateId) {
      case 1:
        return /*#__PURE__*/_react.default.createElement(_BlogCard.default, {
          list: (_state$section3 = state.section) === null || _state$section3 === void 0 ? void 0 : (_state$section3$users = _state$section3.users_list) === null || _state$section3$users === void 0 ? void 0 : _state$section3$users.list,
          maxItems: (_state$section4 = state.section) === null || _state$section4 === void 0 ? void 0 : _state$section4.max_items,
          slug: (_state$section5 = state.section) === null || _state$section5 === void 0 ? void 0 : _state$section5.slug,
          isSourceWebConsole: isSourceWebConsole,
          onWrapperClick: onWrapperClick
        });

      case 2:
        return /*#__PURE__*/_react.default.createElement(_BlogCard.default, {
          list: (_state$section6 = state.section) === null || _state$section6 === void 0 ? void 0 : (_state$section6$users = _state$section6.users_list) === null || _state$section6$users === void 0 ? void 0 : _state$section6$users.list,
          maxItems: (_state$section7 = state.section) === null || _state$section7 === void 0 ? void 0 : _state$section7.max_items,
          slug: (_state$section8 = state.section) === null || _state$section8 === void 0 ? void 0 : _state$section8.slug,
          isSourceWebConsole: isSourceWebConsole,
          onWrapperClick: onWrapperClick
        });

      default:
        return "";
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    id: "blog_section_1",
    className: "blog-main-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "section_title",
    className: "black section-title tc",
    onClick: () => onWrapperClick({
      parentKey: "",
      itemIndex: null,
      keyToBeUpdated: "section_title",
      childKeyToBeReplaced: "display_text"
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "fw6 heading ".concat(isSourceWebConsole ? "title-hover" : "")
  }, (_state$section9 = state.section) === null || _state$section9 === void 0 ? void 0 : (_state$section9$secti = _state$section9.section_title) === null || _state$section9$secti === void 0 ? void 0 : _state$section9$secti.display_text)), renderCard((_state$section10 = state.section) === null || _state$section10 === void 0 ? void 0 : (_state$section10$user = _state$section10.users_list) === null || _state$section10$user === void 0 ? void 0 : _state$section10$user.cardTemplateId), (_state$section11 = state.section) !== null && _state$section11 !== void 0 && _state$section11.max_items ? /*#__PURE__*/_react.default.createElement("section", {
    className: "flex justify-center items-center view-more-btn--container"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: onViewMoreBtnClick,
    className: "view-more-btn"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "w-100 tc"
  }, "View More"))) : null);
}

/***/ }),

/***/ 736975:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = BlogCard1;

__webpack_require__(76265);

__webpack_require__(564043);

__webpack_require__(709873);

__webpack_require__(386544);

__webpack_require__(857267);

var _react = _interopRequireWildcard(__webpack_require__(667294));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function BlogCard1(props) {
  const [listItems, setListItems] = (0, _react.useState)(props.list || []);
  (0, _react.useEffect)(() => {
    var _props$list;

    if (props.maxItems && props !== null && props !== void 0 && (_props$list = props.list) !== null && _props$list !== void 0 && _props$list.length) {
      setListItems(props.list.slice(0, props.maxItems));
    }
  }, [props.maxItems]);

  const onItemClick = index => {
    if (!props.isSourceWebConsole) {
      const link = window.location.href.split("");
      const ifLastCharSlash = link[link.length - 1] === "/";
      if (props.slug) window.location.href = "".concat(window.location.href).concat(ifLastCharSlash ? "" : "/", "p/").concat(props.slug, "/").concat(index);else window.location.href = "".concat(window.location.href).concat(ifLastCharSlash ? "" : "/").concat(index);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    id: "users_list",
    className: "flex flex-wrap justify-center blog-card-main-container"
  }, !!listItems && (listItems === null || listItems === void 0 ? void 0 : listItems.map((item, index) => {
    var _item$image, _item$heading, _item$heading2, _item$description;

    return /*#__PURE__*/_react.default.createElement("div", {
      id: item.id,
      key: index,
      className: "list-card list-card-blog w-100-l flex flex-column relative ".concat(!props.isSourceWebConsole && "pointer"),
      onClick: () => onItemClick(index)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex-column items-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "blog-image flex items-center justify-center relative"
    }, item !== null && item !== void 0 && (_item$image = item.image) !== null && _item$image !== void 0 && _item$image.url ? /*#__PURE__*/_react.default.createElement("img", {
      id: item.id + "_" + "image",
      src: item.image.url,
      className: "card-image"
    }) : null, item !== null && item !== void 0 && item.date ? /*#__PURE__*/_react.default.createElement("div", {
      className: "date-box f5 flex flex-column justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "f3 fw6"
    }, item === null || item === void 0 ? void 0 : item.date.selected_date), /*#__PURE__*/_react.default.createElement("div", {
      className: "month-selected"
    }, item === null || item === void 0 ? void 0 : item.date.selected_month)) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: "w-100 card-body"
    }, item !== null && item !== void 0 && (_item$heading = item.heading) !== null && _item$heading !== void 0 && _item$heading.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      id: item.id + "_" + "blog-heading",
      className: "mb2 f4 fw7"
    }, item === null || item === void 0 ? void 0 : (_item$heading2 = item.heading) === null || _item$heading2 === void 0 ? void 0 : _item$heading2.display_text) : null, item !== null && item !== void 0 && (_item$description = item.description) !== null && _item$description !== void 0 && _item$description.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      id: item.id + "_" + "blog-body",
      className: "pb4"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "f5 o-50 card-body__text"
    }, item === null || item === void 0 ? void 0 : item.description.display_text.replace(/<[^>]*>/g, '').slice(0, 150), "... "), " ", /*#__PURE__*/_react.default.createElement("span", {
      className: "fw6 f5 underline-hover pointer"
    }, "Read Full Blog")) : null)), props.isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
      className: "action-container absolute flex flex-column justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "edit-btn pointer relative",
      onClick: () => props.onWrapperClick({
        parentKey: "users_list",
        itemIndex: index,
        keyToBeUpdated: "",
        childKeyToBeReplaced: ""
      })
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/blackedit.png"
    }), "Edit"), /*#__PURE__*/_react.default.createElement("button", {
      className: "remove-btn pointer relative",
      onClick: () => props.onWrapperClick({
        parentKey: "users_list",
        itemIndex: index,
        keyToBeUpdated: "",
        childKeyToBeReplaced: "",
        operation: "delete"
      })
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/removeicon.png"
    }), "Remove")));
  })), props.isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
    className: "add-new-card add-new-card-blog flex flex-column items-center justify-center pointer",
    onClick: () => props.onWrapperClick({
      parentKey: "users_list",
      itemIndex: "",
      keyToBeUpdated: "",
      childKeyToBeReplaced: "",
      operation: "add"
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "plus-sign"
  }, "+"), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, "Add New")));
}

/***/ }),

/***/ 595921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Card1;

__webpack_require__(76265);

var _react = _interopRequireWildcard(__webpack_require__(667294));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Card1(props) {
  const [listItems, setListItems] = (0, _react.useState)(props.list || []);
  (0, _react.useEffect)(() => {
    var _props$list;

    if (props.maxItems && props !== null && props !== void 0 && (_props$list = props.list) !== null && _props$list !== void 0 && _props$list.length) {
      setListItems(props.list.slice(0, props.maxItems));
    } else {
      setListItems(props.list || []);
    }
  }, [props.maxItems, props.list]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "users_list",
    className: "flex flex-wrap list-card-main-container"
  }, !!listItems && (listItems === null || listItems === void 0 ? void 0 : listItems.map((item, index) => {
    var _item$feedback, _item$image, _item$user_name, _item$user_designatio, _item$user_designatio2;

    return /*#__PURE__*/_react.default.createElement("div", {
      id: item.id,
      key: index,
      className: "list-card w-100-l flex flex-column justify-between relative"
    }, item !== null && item !== void 0 && (_item$feedback = item.feedback) !== null && _item$feedback !== void 0 && _item$feedback.display_text ? /*#__PURE__*/_react.default.createElement("p", {
      id: item.id + "_" + "feedback",
      className: "mt0 mb4 f6"
    }, item === null || item === void 0 ? void 0 : item.feedback.display_text) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex items-center"
    }, item !== null && item !== void 0 && (_item$image = item.image) !== null && _item$image !== void 0 && _item$image.url ? /*#__PURE__*/_react.default.createElement("img", {
      id: item.id + "_" + "image",
      src: item.image.url,
      className: "card-image"
    }) : null, /*#__PURE__*/_react.default.createElement("div", null, item !== null && item !== void 0 && (_item$user_name = item.user_name) !== null && _item$user_name !== void 0 && _item$user_name.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      id: item.id + "_" + "name",
      className: "f5 b pb1"
    }, item === null || item === void 0 ? void 0 : item.user_name.display_text) : null, item !== null && item !== void 0 && (_item$user_designatio = item.user_designation) !== null && _item$user_designatio !== void 0 && _item$user_designatio.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      id: item.id + "_" + "designation",
      className: "mid-gray f7 tl"
    }, item === null || item === void 0 ? void 0 : (_item$user_designatio2 = item.user_designation) === null || _item$user_designatio2 === void 0 ? void 0 : _item$user_designatio2.display_text) : null)), props.isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
      className: "action-container absolute flex flex-column justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "edit-btn pointer relative",
      onClick: () => props.onWrapperClick({
        parentKey: "users_list",
        itemIndex: index,
        keyToBeUpdated: "",
        childKeyToBeReplaced: ""
      })
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/blackedit.png"
    }), "Edit"), /*#__PURE__*/_react.default.createElement("button", {
      className: "remove-btn pointer relative",
      onClick: () => props.onWrapperClick({
        parentKey: "users_list",
        itemIndex: index,
        keyToBeUpdated: "",
        childKeyToBeReplaced: "",
        operation: "delete"
      })
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/removeicon.png"
    }), "Remove")));
  })), props.isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
    className: "add-new-card flex flex-column items-center justify-center pointer",
    onClick: () => props.onWrapperClick({
      parentKey: "users_list",
      itemIndex: "",
      keyToBeUpdated: "",
      childKeyToBeReplaced: "",
      operation: "add"
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "plus-sign"
  }, "+"), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, "Add New")));
}

/***/ }),

/***/ 502255:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = FaqTemplate1;

__webpack_require__(76265);

var _react = _interopRequireWildcard(__webpack_require__(667294));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function FaqTemplate1(props) {
  var _state$section, _state$section$sectio, _state$section2, _state$section2$quest, _state$section2$quest2;

  const [state, setState] = (0, _react.useState)({
    section: {}
  });
  const [isSourceWebConsole, setSource] = (0, _react.useState)(false);
  const [expandedSection, setExapnsionSection] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    setState({
      section: props === null || props === void 0 ? void 0 : props.section
    });

    if ((props === null || props === void 0 ? void 0 : props.source) === "web-console") {
      setSource(true);
    }
  }, [props]);

  const onWrapperClick = dataReceived => {
    if (props.onElementClick && isSourceWebConsole) {
      props.onElementClick(_objectSpread(_objectSpread({}, dataReceived), {}, {
        templateId: props.templateId
      }));
    }
  };

  const toggleExpandedSection = questionIndex => {
    if (expandedSection[questionIndex]) setExapnsionSection({});else setExapnsionSection({
      [questionIndex]: true
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "faq-template-1-container w-100 flex flex-column items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "f3 fw6 heading"
  }, state === null || state === void 0 ? void 0 : (_state$section = state.section) === null || _state$section === void 0 ? void 0 : (_state$section$sectio = _state$section.section_title) === null || _state$section$sectio === void 0 ? void 0 : _state$section$sectio.display_text), state !== null && state !== void 0 && (_state$section2 = state.section) !== null && _state$section2 !== void 0 && (_state$section2$quest = _state$section2.questions_list) !== null && _state$section2$quest !== void 0 && (_state$section2$quest2 = _state$section2$quest.list) !== null && _state$section2$quest2 !== void 0 && _state$section2$quest2.length ? state.section.questions_list.list.map((question, index) => {
    var _question$question_te, _question$question_de;

    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "question-box relative w-100",
      onClick: () => toggleExpandedSection(index)
    }, question !== null && question !== void 0 && (_question$question_te = question.question_text) !== null && _question$question_te !== void 0 && _question$question_te.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      className: "f4 b question-title flex items-center justify-between ".concat(expandedSection[index] ? "show-border" : "")
    }, /*#__PURE__*/_react.default.createElement("span", null, question.question_text.display_text), expandedSection[index] ? /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/longtail/addpages/ic-minus-red.svg",
      alt: ""
    }) : /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/longtail/addpages/ic-red-plus.svg",
      alt: ""
    })) : null, expandedSection[index] && question !== null && question !== void 0 && (_question$question_de = question.question_description) !== null && _question$question_de !== void 0 && _question$question_de.display_text ? /*#__PURE__*/_react.default.createElement("div", {
      className: "f5 question-desc"
    }, question.question_description.display_text) : null, isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
      className: "action-container absolute flex justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "remove-btn pointer flex relative items-center",
      onClick: e => {
        e.stopPropagation();
        onWrapperClick({
          parentKey: "questions_list",
          itemIndex: index,
          keyToBeUpdated: "",
          childKeyToBeReplaced: "",
          operation: "delete"
        });
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/removeicon.png"
    }), "Remove"), /*#__PURE__*/_react.default.createElement("button", {
      className: "edit-btn pointer",
      onClick: e => {
        e.stopPropagation();
        onWrapperClick({
          parentKey: "questions_list",
          itemIndex: index,
          keyToBeUpdated: "",
          childKeyToBeReplaced: ""
        });
      }
    }, "Edit")));
  }) : null, isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
    className: "add-new-btn flex justify-center items-center pointer",
    onClick: () => onWrapperClick({
      parentKey: "questions_list",
      itemIndex: "",
      keyToBeUpdated: "",
      childKeyToBeReplaced: "",
      operation: "add"
    })
  }, "+ Add New FAQ"));
}

/***/ }),

/***/ 37031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(386544);

var _react = _interopRequireDefault(__webpack_require__(667294));

var _NavigationItems = _interopRequireDefault(__webpack_require__(304519));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Footer = props => {
  var _props$storeData, _props$storeData$stor, _props$storeData2, _props$storeData2$sto, _props$storeData3, _props$storeData3$sto, _props$storeData4, _props$storeData4$sto, _props$storeData5, _props$storeData5$sto, _props$storeData6, _props$storeData6$sto, _props$storeData7, _props$storeData7$sto, _props$storeData8, _props$storeData8$sto, _props$storeData9, _props$storeData9$own, _props$storeData10, _props$storeData10$ow, _props$storeData11, _props$storeData11$ow, _props$storeData12, _props$storeData12$ow, _props$storeData13, _props$storeData13$ad, _props$storeData14, _props$storeData14$ad;

  // const SOCIAL_MEDIA = [
  //   {
  //     name: "facebook",
  //     imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/fbicon.png"
  //   },
  //   {
  //     name: "instagram",
  //     imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/instaicon.png"
  //   },
  //   {
  //     name: "whatsapp",
  //     imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/waicon.png"
  //   },
  //   {
  //     name: "twitter",
  //     imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/twittercon.png"
  //   },
  //   {
  //     name: "youtube",
  //     imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/yticon.png"
  //   },
  //   {
  //     name: "linkedin",
  //     imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/linkedinicon.png"
  //   },
  // ];
  const renderAddress = () => {
    const {
      address
    } = props === null || props === void 0 ? void 0 : props.storeData;
    return address && Object.keys(address).length > 0 && "".concat((address === null || address === void 0 ? void 0 : address.address_1) !== '' ? address === null || address === void 0 ? void 0 : address.address_1 : '').concat((address === null || address === void 0 ? void 0 : address.address_2) !== '' ? ", ".concat(address === null || address === void 0 ? void 0 : address.address_2) : '').concat((address === null || address === void 0 ? void 0 : address.city) !== '' ? ", ".concat(address === null || address === void 0 ? void 0 : address.city) : '').concat((address === null || address === void 0 ? void 0 : address.state) !== '' ? ", ".concat(address === null || address === void 0 ? void 0 : address.state) : '').concat((address === null || address === void 0 ? void 0 : address.pincode) !== '' ? ", ".concat(address === null || address === void 0 ? void 0 : address.pincode) : '');
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "templateFooter"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "templateFooter__section footer-shop-desc"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "top-section"
  }, (props === null || props === void 0 ? void 0 : (_props$storeData = props.storeData) === null || _props$storeData === void 0 ? void 0 : (_props$storeData$stor = _props$storeData.store_info) === null || _props$storeData$stor === void 0 ? void 0 : _props$storeData$stor.logo_image) && /*#__PURE__*/_react.default.createElement("img", {
    src: props === null || props === void 0 ? void 0 : (_props$storeData2 = props.storeData) === null || _props$storeData2 === void 0 ? void 0 : (_props$storeData2$sto = _props$storeData2.store_info) === null || _props$storeData2$sto === void 0 ? void 0 : _props$storeData2$sto.logo_image,
    height: "53",
    width: "67"
  }), /*#__PURE__*/_react.default.createElement("h2", null, (_props$storeData3 = props.storeData) === null || _props$storeData3 === void 0 ? void 0 : (_props$storeData3$sto = _props$storeData3.store_info) === null || _props$storeData3$sto === void 0 ? void 0 : _props$storeData3$sto.name)), (props === null || props === void 0 ? void 0 : (_props$storeData4 = props.storeData) === null || _props$storeData4 === void 0 ? void 0 : (_props$storeData4$sto = _props$storeData4.store_info) === null || _props$storeData4$sto === void 0 ? void 0 : _props$storeData4$sto.description) && /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom-section"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "About Us"), (props === null || props === void 0 ? void 0 : (_props$storeData5 = props.storeData) === null || _props$storeData5 === void 0 ? void 0 : (_props$storeData5$sto = _props$storeData5.store_info) === null || _props$storeData5$sto === void 0 ? void 0 : _props$storeData5$sto.description.length) > 160 ? /*#__PURE__*/_react.default.createElement("p", {
    className: "desc-text"
  }, props === null || props === void 0 ? void 0 : (_props$storeData6 = props.storeData) === null || _props$storeData6 === void 0 ? void 0 : (_props$storeData6$sto = _props$storeData6.store_info) === null || _props$storeData6$sto === void 0 ? void 0 : _props$storeData6$sto.description.substr(0, 160), "...") : /*#__PURE__*/_react.default.createElement("p", {
    className: "desc-text"
  }, props === null || props === void 0 ? void 0 : (_props$storeData7 = props.storeData) === null || _props$storeData7 === void 0 ? void 0 : (_props$storeData7$sto = _props$storeData7.store_info) === null || _props$storeData7$sto === void 0 ? void 0 : _props$storeData7$sto.description)), (props === null || props === void 0 ? void 0 : (_props$storeData8 = props.storeData) === null || _props$storeData8 === void 0 ? void 0 : (_props$storeData8$sto = _props$storeData8.store_info) === null || _props$storeData8$sto === void 0 ? void 0 : _props$storeData8$sto.description.length) > 160 && /*#__PURE__*/_react.default.createElement("p", {
    className: "desc-text__view-more"
  }, "View More")), /*#__PURE__*/_react.default.createElement("div", {
    className: "templateFooter__section"
  }, /*#__PURE__*/_react.default.createElement(_NavigationItems.default, {
    categories: props === null || props === void 0 ? void 0 : props.categories,
    horizontalNav: false,
    navItemList: props === null || props === void 0 ? void 0 : props.navItemList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "templateFooter__section store-information"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, "Visit our store"), /*#__PURE__*/_react.default.createElement("p", {
    className: "address-text"
  }, renderAddress())), /*#__PURE__*/_react.default.createElement("div", null, (props === null || props === void 0 ? void 0 : (_props$storeData9 = props.storeData) === null || _props$storeData9 === void 0 ? void 0 : (_props$storeData9$own = _props$storeData9.owner) === null || _props$storeData9$own === void 0 ? void 0 : _props$storeData9$own.email_id) && /*#__PURE__*/_react.default.createElement("div", {
    className: "store-information__subsection",
    style: {
      marginTop: 40
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://cdn.dotpe.in/kiranaStatic/icons/mail.png"
  })), /*#__PURE__*/_react.default.createElement("p", null, props === null || props === void 0 ? void 0 : (_props$storeData10 = props.storeData) === null || _props$storeData10 === void 0 ? void 0 : (_props$storeData10$ow = _props$storeData10.owner) === null || _props$storeData10$ow === void 0 ? void 0 : _props$storeData10$ow.email_id)), (props === null || props === void 0 ? void 0 : (_props$storeData11 = props.storeData) === null || _props$storeData11 === void 0 ? void 0 : (_props$storeData11$ow = _props$storeData11.owner) === null || _props$storeData11$ow === void 0 ? void 0 : _props$storeData11$ow.phone) && /*#__PURE__*/_react.default.createElement("div", {
    className: "store-information__subsection"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://cdn.dotpe.in/kiranaStatic/icons/ringingtelephone.png"
  })), /*#__PURE__*/_react.default.createElement("p", null, props === null || props === void 0 ? void 0 : (_props$storeData12 = props.storeData) === null || _props$storeData12 === void 0 ? void 0 : (_props$storeData12$ow = _props$storeData12.owner) === null || _props$storeData12$ow === void 0 ? void 0 : _props$storeData12$ow.phone)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "templateFooter__section"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    width: "100%",
    height: "250",
    src: 'https://www.google.com/maps/embed/v1/place?key=AIzaSyA6BuhugILHbrfHoUkHcVzhEGeRhhX2ErA&q=' + (props === null || props === void 0 ? void 0 : (_props$storeData13 = props.storeData) === null || _props$storeData13 === void 0 ? void 0 : (_props$storeData13$ad = _props$storeData13.address) === null || _props$storeData13$ad === void 0 ? void 0 : _props$storeData13$ad.latitude) + ',' + (props === null || props === void 0 ? void 0 : (_props$storeData14 = props.storeData) === null || _props$storeData14 === void 0 ? void 0 : (_props$storeData14$ad = _props$storeData14.address) === null || _props$storeData14$ad === void 0 ? void 0 : _props$storeData14$ad.longitude)
  })));
};

var _default = Footer;
exports["default"] = _default;

/***/ }),

/***/ 388563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(76265);

var _react = _interopRequireWildcard(__webpack_require__(667294));

var _NavigationItems = _interopRequireDefault(__webpack_require__(304519));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const IconList = [{
  name: "search",
  imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/search.png",
  href: 'search'
}, {
  name: "whatsapp",
  imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/whatsapp.png"
}, {
  name: "orders",
  imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/user.png",
  href: 'orders'
}, {
  name: "cart",
  imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/shoppingcart.png",
  href: 'cart'
}];

const Header = props => {
  var _props$storeData, _props$storeData$stor;

  const [iconListState] = (0, _react.useState)(IconList);

  const onHeaderLinkshandle = _ref => {
    let {
      type,
      href
    } = _ref;
    props.onHandleLink && props.onHandlePageClick(type, href);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "templateHeader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "templateHeader__inner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "templateHeader__inner--subsection"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "store-name",
    onClick: () => props.onHandlePageClick('')
  }, (_props$storeData = props.storeData) === null || _props$storeData === void 0 ? void 0 : (_props$storeData$stor = _props$storeData.store_info) === null || _props$storeData$stor === void 0 ? void 0 : _props$storeData$stor.name), /*#__PURE__*/_react.default.createElement(_NavigationItems.default, {
    categories: props === null || props === void 0 ? void 0 : props.categories,
    onHandlePageClick: props.onHandlePageClick,
    onCategoriesLinkHandle: props.onCategoriesLinkHandle,
    navItemList: props === null || props === void 0 ? void 0 : props.navItemList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "templateHeader__inner--subsection"
  }, iconListState.map(icon => /*#__PURE__*/_react.default.createElement("img", {
    key: icon.name,
    src: icon.imgSrc,
    width: "25",
    height: "25",
    onClick: () => onHandlePageClick(icon.href),
    style: icon.name === "search" ? {
      filter: "brightness(0)"
    } : {}
  })))));
};

var _default = Header;
exports["default"] = _default;

/***/ }),

/***/ 304519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(76265);

var _react = _interopRequireWildcard(__webpack_require__(667294));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const NavigationItems = _ref => {
  let {
    categories,
    horizontalNav = true,
    onCategoriesLinkHandle,
    onHandlePageClick,
    navItemList
  } = _ref;

  const navList = () => {
    if (navItemList.length > 5) {
      const navListArr = [...navItemList];
      navListArr.length = 5;
      navListArr.push("More");
      return navListArr;
    }

    return navItemList;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "templateNavItems ".concat(horizontalNav ? "" : "vertical-nav")
  }, navItemList && navItemList.length > 0 && navList().map(item => /*#__PURE__*/_react.default.createElement("span", {
    className: "templateNavItems__item"
  }, item)));
};

var _default = NavigationItems;
exports["default"] = _default;

/***/ }),

/***/ 499211:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SocialMediaTemplate1;

__webpack_require__(76265);

var _react = _interopRequireWildcard(__webpack_require__(667294));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SocialMediaTemplate1(props) {
  var _state$section, _state$section2, _state$section2$store, _state$section3, _state$section4, _state$section5, _state$section5$secti, _state$section6, _state$section6$media, _state$section6$media2;

  const [state, setState] = (0, _react.useState)({
    section: {}
  });
  const [isSourceWebConsole, setSource] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setState({
      section: props === null || props === void 0 ? void 0 : props.section
    });

    if ((props === null || props === void 0 ? void 0 : props.source) === "web-console") {
      setSource(true);
    }
  }, [props]);

  const onWrapperClick = dataReceived => {
    if (props.onElementClick && isSourceWebConsole) {
      props.onElementClick(_objectSpread(_objectSpread({}, dataReceived), {}, {
        templateId: props.templateId
      }));
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "social-media-template-1-container w-100 flex flex-column items-center"
  }, state !== null && state !== void 0 && (_state$section = state.section) !== null && _state$section !== void 0 && _state$section.store_image ? /*#__PURE__*/_react.default.createElement("div", {
    className: "store-image ponter relative"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: state === null || state === void 0 ? void 0 : (_state$section2 = state.section) === null || _state$section2 === void 0 ? void 0 : (_state$section2$store = _state$section2.store_image) === null || _state$section2$store === void 0 ? void 0 : _state$section2$store.url,
    alt: state === null || state === void 0 ? void 0 : (_state$section3 = state.section) === null || _state$section3 === void 0 ? void 0 : _state$section3.display_text
  }), isSourceWebConsole ? /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute hover-store-image flex justify-center items-center pointer",
    onClick: () => onWrapperClick({
      parentKey: "",
      itemIndex: null,
      keyToBeUpdated: "store_image",
      childKeyToBeReplaced: "url"
    })
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "image-edit-btn flex items-center justify-center"
  }, "Edit Image")) : null) : null, state !== null && state !== void 0 && (_state$section4 = state.section) !== null && _state$section4 !== void 0 && _state$section4.section_title ? /*#__PURE__*/_react.default.createElement("div", {
    className: "f4 b section-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(isSourceWebConsole ? "title-hover" : ""),
    onClick: () => onWrapperClick({
      parentKey: "",
      itemIndex: null,
      keyToBeUpdated: "section_title",
      childKeyToBeReplaced: "display_text"
    })
  }, state === null || state === void 0 ? void 0 : (_state$section5 = state.section) === null || _state$section5 === void 0 ? void 0 : (_state$section5$secti = _state$section5.section_title) === null || _state$section5$secti === void 0 ? void 0 : _state$section5$secti.display_text)) : null, state !== null && state !== void 0 && (_state$section6 = state.section) !== null && _state$section6 !== void 0 && (_state$section6$media = _state$section6.media_links) !== null && _state$section6$media !== void 0 && (_state$section6$media2 = _state$section6$media.list) !== null && _state$section6$media2 !== void 0 && _state$section6$media2.length ? state.section.media_links.list.map((media, index) => {
    var _media$image;

    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "flex items-center justify-center social-media-links pointer relative",
      onClick: () => !isSourceWebConsole && window.open(media.media_url.url, "_blank")
    }, media !== null && media !== void 0 && media.image ? /*#__PURE__*/_react.default.createElement("img", {
      src: (_media$image = media.image) === null || _media$image === void 0 ? void 0 : _media$image.url,
      alt: media === null || media === void 0 ? void 0 : media.image.display_text,
      className: "absolute media-image"
    }) : null, media !== null && media !== void 0 && media.media_name ? /*#__PURE__*/_react.default.createElement("div", {
      className: "media-text tc self-center"
    }, media === null || media === void 0 ? void 0 : media.media_name.display_text) : null, isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
      className: "action-container absolute flex justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "remove-btn pointer relative justify-center",
      onClick: e => {
        e.stopPropagation();
        onWrapperClick({
          parentKey: "media_links",
          itemIndex: index,
          keyToBeUpdated: "",
          childKeyToBeReplaced: "",
          operation: "delete"
        });
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/removeicon.png"
    }), "Remove"), /*#__PURE__*/_react.default.createElement("button", {
      className: "edit-btn pointer",
      onClick: e => {
        e.stopPropagation();
        onWrapperClick({
          parentKey: "media_links",
          itemIndex: index,
          keyToBeUpdated: "",
          childKeyToBeReplaced: ""
        });
      }
    }, "Edit")));
  }) : null, isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
    className: "add-new-btn flex justify-center items-center pointer",
    onClick: () => onWrapperClick({
      parentKey: "media_links",
      itemIndex: "",
      keyToBeUpdated: "",
      childKeyToBeReplaced: "",
      operation: "add"
    })
  }, "+ Add New"));
}

/***/ }),

/***/ 573096:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = TestimonialTemplate1;

__webpack_require__(76265);

__webpack_require__(564043);

__webpack_require__(709873);

var _react = _interopRequireWildcard(__webpack_require__(667294));

var _Card = _interopRequireDefault(__webpack_require__(595921));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TestimonialTemplate1(props) {
  var _state$section8, _state$section8$secti, _state$section9, _state$section9$users, _state$section10;

  const [state, setState] = (0, _react.useState)({
    section: {}
  });
  const [isSourceWebConsole, setSource] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setState({
      section: props === null || props === void 0 ? void 0 : props.section
    });

    if ((props === null || props === void 0 ? void 0 : props.source) === "web-console") {
      setSource(true);
    }
  }, [props]);

  const onWrapperClick = dataReceived => {
    if (props.onElementClick && isSourceWebConsole) {
      props.onElementClick(_objectSpread(_objectSpread({}, dataReceived), {}, {
        templateId: props.templateId
      }));
    }
  };

  const renderCard = cardTemplateId => {
    var _state$section, _state$section$users_, _state$section2, _state$section3, _state$section4, _state$section4$users, _state$section5;

    switch (cardTemplateId) {
      case 1:
        return /*#__PURE__*/_react.default.createElement(_Card.default, {
          list: (_state$section = state.section) === null || _state$section === void 0 ? void 0 : (_state$section$users_ = _state$section.users_list) === null || _state$section$users_ === void 0 ? void 0 : _state$section$users_.list,
          maxItems: (_state$section2 = state.section) === null || _state$section2 === void 0 ? void 0 : _state$section2.max_items,
          data: state.section,
          slug: (_state$section3 = state.section) === null || _state$section3 === void 0 ? void 0 : _state$section3.slug,
          isSourceWebConsole: isSourceWebConsole,
          onWrapperClick: onWrapperClick
        });

      case 2:
        return /*#__PURE__*/_react.default.createElement(_Card.default, {
          list: (_state$section4 = state.section) === null || _state$section4 === void 0 ? void 0 : (_state$section4$users = _state$section4.users_list) === null || _state$section4$users === void 0 ? void 0 : _state$section4$users.list,
          maxItems: (_state$section5 = state.section) === null || _state$section5 === void 0 ? void 0 : _state$section5.max_items,
          isSourceWebConsole: isSourceWebConsole,
          onWrapperClick: onWrapperClick
        });

      default:
        return "";
    }
  };

  const onViewMoreBtnClick = () => {
    var _state$section6;

    if (!isSourceWebConsole && (_state$section6 = state.section) !== null && _state$section6 !== void 0 && _state$section6.slug) {
      var _state$section7;

      const link = window.location.href.split("");
      const ifLastCharSlash = link[link.length - 1] === "/";
      window.location.href = "".concat(window.location.href).concat(ifLastCharSlash ? "" : "/", "p/").concat((_state$section7 = state.section) === null || _state$section7 === void 0 ? void 0 : _state$section7.slug);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    id: "testimonial_section_1",
    className: "testimonial-main-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "section_title",
    className: "black section-title tc",
    onClick: () => onWrapperClick({
      parentKey: "",
      itemIndex: null,
      keyToBeUpdated: "section_title",
      childKeyToBeReplaced: "display_text"
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "fw6 heading ".concat(isSourceWebConsole ? "title-hover" : "")
  }, (_state$section8 = state.section) === null || _state$section8 === void 0 ? void 0 : (_state$section8$secti = _state$section8.section_title) === null || _state$section8$secti === void 0 ? void 0 : _state$section8$secti.display_text, " ")), renderCard((_state$section9 = state.section) === null || _state$section9 === void 0 ? void 0 : (_state$section9$users = _state$section9.users_list) === null || _state$section9$users === void 0 ? void 0 : _state$section9$users.cardTemplateId), (_state$section10 = state.section) !== null && _state$section10 !== void 0 && _state$section10.max_items ? /*#__PURE__*/_react.default.createElement("section", {
    className: "flex justify-center items-center view-more-btn--container"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: onViewMoreBtnClick,
    className: "view-more-btn"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "w-100 tc"
  }, "View More"))) : null);
}

/***/ }),

/***/ 934040:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



__webpack_require__(76265);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(667294));

var _Template = _interopRequireDefault(__webpack_require__(573096));

var _Template2 = _interopRequireDefault(__webpack_require__(499211));

var _Template3 = _interopRequireDefault(__webpack_require__(502255));

var _Template4 = _interopRequireDefault(__webpack_require__(121170));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// const TestimonialTemplate1 = lazy(() => import("./TestimonialTemplate/Template1"));
const AddPagesLib = tempId => {
  switch (tempId) {
    case "testimonial":
      return _Template.default;

    case "social_media":
      return _Template2.default;

    case "faq":
      return _Template3.default;

    case "blog":
      return _Template4.default;

    default:
      break;
  }
};

var _default = AddPagesLib;
exports["default"] = _default;

/***/ }),

/***/ 600531:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "qU", ({
  enumerable: true,
  get: function get() {
    return _addPagesLib.default;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _Header.default;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _Footer.default;
  }
});

var _addPagesLib = _interopRequireDefault(__webpack_require__(934040));

var _Header = _interopRequireDefault(__webpack_require__(388563));

var _Footer = _interopRequireDefault(__webpack_require__(37031));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 110509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var isCallable = __webpack_require__(669985);
var tryToString = __webpack_require__(423691);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 952655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var isConstructor = __webpack_require__(519429);
var tryToString = __webpack_require__(423691);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 223550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var isPossiblePrototype = __webpack_require__(60598);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 87370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var wellKnownSymbol = __webpack_require__(844201);
var create = __webpack_require__(225391);
var defineProperty = (__webpack_require__(72560).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 871514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var charAt = (__webpack_require__(110730).charAt);

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 685027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var isObject = __webpack_require__(748999);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 384328:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var toIndexedObject = __webpack_require__(165290);
var toAbsoluteIndex = __webpack_require__(527578);
var lengthOfArrayLike = __webpack_require__(606310);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 606648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 950926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var TO_STRING_TAG_SUPPORT = __webpack_require__(523043);
var isCallable = __webpack_require__(669985);
var classofRaw = __webpack_require__(606648);
var wellKnownSymbol = __webpack_require__(844201);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 8758:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var hasOwn = __webpack_require__(336812);
var ownKeys = __webpack_require__(819152);
var getOwnPropertyDescriptorModule = __webpack_require__(882474);
var definePropertyModule = __webpack_require__(72560);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 581748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var fails = __webpack_require__(203689);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 227807:
/***/ (function(module) {


// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 875773:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var DESCRIPTORS = __webpack_require__(567697);
var definePropertyModule = __webpack_require__(72560);
var createPropertyDescriptor = __webpack_require__(275684);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 275684:
/***/ (function(module) {


module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 862148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var makeBuiltIn = __webpack_require__(98702);
var defineProperty = __webpack_require__(72560);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 11880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var isCallable = __webpack_require__(669985);
var definePropertyModule = __webpack_require__(72560);
var makeBuiltIn = __webpack_require__(98702);
var defineGlobalProperty = __webpack_require__(995014);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 995014:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var global = __webpack_require__(419037);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 567697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var fails = __webpack_require__(203689);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 936420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var global = __webpack_require__(419037);
var isObject = __webpack_require__(748999);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 366338:
/***/ (function(module) {


// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 333265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(936420);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 730071:
/***/ (function(module) {


module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 903615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var global = __webpack_require__(419037);
var userAgent = __webpack_require__(730071);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 972739:
/***/ (function(module) {


// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 79989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var global = __webpack_require__(419037);
var getOwnPropertyDescriptor = (__webpack_require__(882474).f);
var createNonEnumerableProperty = __webpack_require__(875773);
var defineBuiltIn = __webpack_require__(11880);
var defineGlobalProperty = __webpack_require__(995014);
var copyConstructorProperties = __webpack_require__(8758);
var isForced = __webpack_require__(935266);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global[TARGET] && global[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 203689:
/***/ (function(module) {


module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 265773:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(564043);
var call = __webpack_require__(322615);
var defineBuiltIn = __webpack_require__(11880);
var regexpExec = __webpack_require__(756308);
var fails = __webpack_require__(203689);
var wellKnownSymbol = __webpack_require__(844201);
var createNonEnumerableProperty = __webpack_require__(875773);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 761735:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var NATIVE_BIND = __webpack_require__(797215);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 797215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var fails = __webpack_require__(203689);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 322615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var NATIVE_BIND = __webpack_require__(797215);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 941236:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var DESCRIPTORS = __webpack_require__(567697);
var hasOwn = __webpack_require__(336812);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 952743:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);
var aCallable = __webpack_require__(110509);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 768844:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var NATIVE_BIND = __webpack_require__(797215);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 76058:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var global = __webpack_require__(419037);
var isCallable = __webpack_require__(669985);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 154849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var aCallable = __webpack_require__(110509);
var isNullOrUndefined = __webpack_require__(700981);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 327017:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);
var toObject = __webpack_require__(990690);

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 419037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 336812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);
var toObject = __webpack_require__(990690);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 457248:
/***/ (function(module) {


module.exports = {};


/***/ }),

/***/ 802688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var getBuiltIn = __webpack_require__(76058);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 268506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var DESCRIPTORS = __webpack_require__(567697);
var fails = __webpack_require__(203689);
var createElement = __webpack_require__(936420);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 294413:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);
var fails = __webpack_require__(203689);
var classof = __webpack_require__(606648);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 506738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);
var isCallable = __webpack_require__(669985);
var store = __webpack_require__(584091);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 400618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var NATIVE_WEAK_MAP = __webpack_require__(359834);
var global = __webpack_require__(419037);
var isObject = __webpack_require__(748999);
var createNonEnumerableProperty = __webpack_require__(875773);
var hasOwn = __webpack_require__(336812);
var shared = __webpack_require__(584091);
var sharedKey = __webpack_require__(502713);
var hiddenKeys = __webpack_require__(457248);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 669985:
/***/ (function(module) {


// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 519429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);
var fails = __webpack_require__(203689);
var isCallable = __webpack_require__(669985);
var classof = __webpack_require__(950926);
var getBuiltIn = __webpack_require__(76058);
var inspectSource = __webpack_require__(506738);

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 935266:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var fails = __webpack_require__(203689);
var isCallable = __webpack_require__(669985);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 700981:
/***/ (function(module) {


// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 748999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var isCallable = __webpack_require__(669985);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 60598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var isObject = __webpack_require__(748999);

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};


/***/ }),

/***/ 453931:
/***/ (function(module) {


module.exports = false;


/***/ }),

/***/ 830734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var getBuiltIn = __webpack_require__(76058);
var isCallable = __webpack_require__(669985);
var isPrototypeOf = __webpack_require__(623622);
var USE_SYMBOL_AS_UID = __webpack_require__(539525);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 730974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var IteratorPrototype = (__webpack_require__(912013).IteratorPrototype);
var create = __webpack_require__(225391);
var createPropertyDescriptor = __webpack_require__(275684);
var setToStringTag = __webpack_require__(355997);
var Iterators = __webpack_require__(9478);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 91934:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var $ = __webpack_require__(79989);
var call = __webpack_require__(322615);
var IS_PURE = __webpack_require__(453931);
var FunctionName = __webpack_require__(941236);
var isCallable = __webpack_require__(669985);
var createIteratorConstructor = __webpack_require__(730974);
var getPrototypeOf = __webpack_require__(161868);
var setPrototypeOf = __webpack_require__(49385);
var setToStringTag = __webpack_require__(355997);
var createNonEnumerableProperty = __webpack_require__(875773);
var defineBuiltIn = __webpack_require__(11880);
var wellKnownSymbol = __webpack_require__(844201);
var Iterators = __webpack_require__(9478);
var IteratorsCore = __webpack_require__(912013);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 912013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var fails = __webpack_require__(203689);
var isCallable = __webpack_require__(669985);
var isObject = __webpack_require__(748999);
var create = __webpack_require__(225391);
var getPrototypeOf = __webpack_require__(161868);
var defineBuiltIn = __webpack_require__(11880);
var wellKnownSymbol = __webpack_require__(844201);
var IS_PURE = __webpack_require__(453931);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 9478:
/***/ (function(module) {


module.exports = {};


/***/ }),

/***/ 606310:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var toLength = __webpack_require__(643126);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 98702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);
var fails = __webpack_require__(203689);
var isCallable = __webpack_require__(669985);
var hasOwn = __webpack_require__(336812);
var DESCRIPTORS = __webpack_require__(567697);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(941236).CONFIGURABLE);
var inspectSource = __webpack_require__(506738);
var InternalStateModule = __webpack_require__(400618);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 958828:
/***/ (function(module) {


var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 225391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(685027);
var definePropertiesModule = __webpack_require__(298920);
var enumBugKeys = __webpack_require__(972739);
var hiddenKeys = __webpack_require__(457248);
var html = __webpack_require__(802688);
var documentCreateElement = __webpack_require__(936420);
var sharedKey = __webpack_require__(502713);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 298920:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var DESCRIPTORS = __webpack_require__(567697);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(915648);
var definePropertyModule = __webpack_require__(72560);
var anObject = __webpack_require__(685027);
var toIndexedObject = __webpack_require__(165290);
var objectKeys = __webpack_require__(820300);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 72560:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var DESCRIPTORS = __webpack_require__(567697);
var IE8_DOM_DEFINE = __webpack_require__(268506);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(915648);
var anObject = __webpack_require__(685027);
var toPropertyKey = __webpack_require__(218360);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 882474:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var DESCRIPTORS = __webpack_require__(567697);
var call = __webpack_require__(322615);
var propertyIsEnumerableModule = __webpack_require__(949556);
var createPropertyDescriptor = __webpack_require__(275684);
var toIndexedObject = __webpack_require__(165290);
var toPropertyKey = __webpack_require__(218360);
var hasOwn = __webpack_require__(336812);
var IE8_DOM_DEFINE = __webpack_require__(268506);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 172741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var internalObjectKeys = __webpack_require__(554948);
var enumBugKeys = __webpack_require__(972739);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 124178:
/***/ (function(__unused_webpack_module, exports) {


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 161868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var hasOwn = __webpack_require__(336812);
var isCallable = __webpack_require__(669985);
var toObject = __webpack_require__(990690);
var sharedKey = __webpack_require__(502713);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(581748);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 623622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 554948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);
var hasOwn = __webpack_require__(336812);
var toIndexedObject = __webpack_require__(165290);
var indexOf = (__webpack_require__(384328).indexOf);
var hiddenKeys = __webpack_require__(457248);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 820300:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var internalObjectKeys = __webpack_require__(554948);
var enumBugKeys = __webpack_require__(972739);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 949556:
/***/ (function(__unused_webpack_module, exports) {


var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 49385:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(952743);
var isObject = __webpack_require__(748999);
var requireObjectCoercible = __webpack_require__(974684);
var aPossiblePrototype = __webpack_require__(223550);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 235899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var call = __webpack_require__(322615);
var isCallable = __webpack_require__(669985);
var isObject = __webpack_require__(748999);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 819152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var getBuiltIn = __webpack_require__(76058);
var uncurryThis = __webpack_require__(768844);
var getOwnPropertyNamesModule = __webpack_require__(172741);
var getOwnPropertySymbolsModule = __webpack_require__(124178);
var anObject = __webpack_require__(685027);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 266100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var call = __webpack_require__(322615);
var anObject = __webpack_require__(685027);
var isCallable = __webpack_require__(669985);
var classof = __webpack_require__(606648);
var regexpExec = __webpack_require__(756308);

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw new $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 756308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(322615);
var uncurryThis = __webpack_require__(768844);
var toString = __webpack_require__(34327);
var regexpFlags = __webpack_require__(369633);
var stickyHelpers = __webpack_require__(887901);
var shared = __webpack_require__(183430);
var create = __webpack_require__(225391);
var getInternalState = (__webpack_require__(400618).get);
var UNSUPPORTED_DOT_ALL = __webpack_require__(562100);
var UNSUPPORTED_NCG = __webpack_require__(726738);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 369633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var anObject = __webpack_require__(685027);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 887901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var fails = __webpack_require__(203689);
var global = __webpack_require__(419037);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ 562100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var fails = __webpack_require__(203689);
var global = __webpack_require__(419037);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});


/***/ }),

/***/ 726738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var fails = __webpack_require__(203689);
var global = __webpack_require__(419037);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 974684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var isNullOrUndefined = __webpack_require__(700981);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 355997:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var defineProperty = (__webpack_require__(72560).f);
var hasOwn = __webpack_require__(336812);
var wellKnownSymbol = __webpack_require__(844201);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 502713:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var shared = __webpack_require__(183430);
var uid = __webpack_require__(714630);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 584091:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var IS_PURE = __webpack_require__(453931);
var globalThis = __webpack_require__(419037);
var defineGlobalProperty = __webpack_require__(995014);

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.37.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.37.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 183430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var store = __webpack_require__(584091);

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};


/***/ }),

/***/ 576373:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var anObject = __webpack_require__(685027);
var aConstructor = __webpack_require__(952655);
var isNullOrUndefined = __webpack_require__(700981);
var wellKnownSymbol = __webpack_require__(844201);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 110730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);
var toIntegerOrInfinity = __webpack_require__(668700);
var toString = __webpack_require__(34327);
var requireObjectCoercible = __webpack_require__(974684);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 550146:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(903615);
var fails = __webpack_require__(203689);
var global = __webpack_require__(419037);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 527578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var toIntegerOrInfinity = __webpack_require__(668700);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 165290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(294413);
var requireObjectCoercible = __webpack_require__(974684);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 668700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var trunc = __webpack_require__(958828);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 643126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var toIntegerOrInfinity = __webpack_require__(668700);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 990690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var requireObjectCoercible = __webpack_require__(974684);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 688732:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var call = __webpack_require__(322615);
var isObject = __webpack_require__(748999);
var isSymbol = __webpack_require__(830734);
var getMethod = __webpack_require__(154849);
var ordinaryToPrimitive = __webpack_require__(235899);
var wellKnownSymbol = __webpack_require__(844201);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 218360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var toPrimitive = __webpack_require__(688732);
var isSymbol = __webpack_require__(830734);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 523043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var wellKnownSymbol = __webpack_require__(844201);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 34327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var classof = __webpack_require__(950926);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 423691:
/***/ (function(module) {


var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 714630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var uncurryThis = __webpack_require__(768844);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 539525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(550146);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 915648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var DESCRIPTORS = __webpack_require__(567697);
var fails = __webpack_require__(203689);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 359834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var global = __webpack_require__(419037);
var isCallable = __webpack_require__(669985);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 844201:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var global = __webpack_require__(419037);
var shared = __webpack_require__(183430);
var hasOwn = __webpack_require__(336812);
var uid = __webpack_require__(714630);
var NATIVE_SYMBOL = __webpack_require__(550146);
var USE_SYMBOL_AS_UID = __webpack_require__(539525);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 800752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var toIndexedObject = __webpack_require__(165290);
var addToUnscopables = __webpack_require__(87370);
var Iterators = __webpack_require__(9478);
var InternalStateModule = __webpack_require__(400618);
var defineProperty = (__webpack_require__(72560).f);
var defineIterator = __webpack_require__(91934);
var createIterResultObject = __webpack_require__(227807);
var IS_PURE = __webpack_require__(453931);
var DESCRIPTORS = __webpack_require__(567697);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ 564043:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


var $ = __webpack_require__(79989);
var exec = __webpack_require__(756308);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 857267:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


var apply = __webpack_require__(761735);
var call = __webpack_require__(322615);
var uncurryThis = __webpack_require__(768844);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(265773);
var fails = __webpack_require__(203689);
var anObject = __webpack_require__(685027);
var isCallable = __webpack_require__(669985);
var isNullOrUndefined = __webpack_require__(700981);
var toIntegerOrInfinity = __webpack_require__(668700);
var toLength = __webpack_require__(643126);
var toString = __webpack_require__(34327);
var requireObjectCoercible = __webpack_require__(974684);
var advanceStringIndex = __webpack_require__(871514);
var getMethod = __webpack_require__(154849);
var getSubstitution = __webpack_require__(327017);
var regExpExec = __webpack_require__(266100);
var wellKnownSymbol = __webpack_require__(844201);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ 709873:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


var call = __webpack_require__(322615);
var uncurryThis = __webpack_require__(768844);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(265773);
var anObject = __webpack_require__(685027);
var isNullOrUndefined = __webpack_require__(700981);
var requireObjectCoercible = __webpack_require__(974684);
var speciesConstructor = __webpack_require__(576373);
var advanceStringIndex = __webpack_require__(871514);
var toLength = __webpack_require__(643126);
var toString = __webpack_require__(34327);
var getMethod = __webpack_require__(154849);
var regExpExec = __webpack_require__(266100);
var stickyHelpers = __webpack_require__(887901);
var fails = __webpack_require__(203689);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var push = uncurryThis([].push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' ||
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  'test'.split(/(?:)/, -1).length !== 4 ||
  'ab'.split(/(?:ab)*/).length !== 2 ||
  '.'.split(/(.?)(.?)/).length !== 4 ||
  // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  '.'.split(/()()/).length > 1 ||
  ''.split(/.?/).length;

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit = '0'.split(undefined, 0).length ? function (separator, limit) {
    return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
  } : nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);

      if (!BUGGY) {
        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
        if (res.done) return res.value;
      }

      var C = speciesConstructor(rx, RegExp);
      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');
      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ 386544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(79989);
var DESCRIPTORS = __webpack_require__(567697);
var global = __webpack_require__(419037);
var uncurryThis = __webpack_require__(768844);
var hasOwn = __webpack_require__(336812);
var isCallable = __webpack_require__(669985);
var isPrototypeOf = __webpack_require__(623622);
var toString = __webpack_require__(34327);
var defineBuiltInAccessor = __webpack_require__(862148);
var copyConstructorProperties = __webpack_require__(8758);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 76265:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


var global = __webpack_require__(419037);
var DOMIterables = __webpack_require__(366338);
var DOMTokenListPrototype = __webpack_require__(333265);
var ArrayIteratorMethods = __webpack_require__(800752);
var createNonEnumerableProperty = __webpack_require__(875773);
var setToStringTag = __webpack_require__(355997);
var wellKnownSymbol = __webpack_require__(844201);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ })

}]);